import auth from './auth'

export const authGuard = (to, from, next) => {
  return auth
    .check()
    .then(() => next())
    .catch(() => next('/login'))
}
export const guestGuard = (to, from, next) => {
  return auth
    .check()
    .then(() => next('/'))
    .catch(() => next())
}

const permissionGuard = (permission) => (to, from, next) => {
  if (auth.checkPermission(permission)) {
    next()
  } else {
    next(false)
  }
}

const mainPageGuard = (to, from, next) => {
  if (auth.checkPermission('web_main')) {
    return next()
  }
  if (auth.checkPermission('web_sales')) {
    return next('/reports/sales')
  }
  if (auth.checkPermission('web_service')) {
    return next('/service')
  }
}

const adminGuard = (to, from, next) => {
  if (auth.isAdmin()) {
    next()
  } else {
    next(false)
  }
}

export default [
  {
    path: '/login',
    component: require('./pages/login.vue').default,
    beforeEnter: guestGuard,
  },
  {
    path: '/',
    component: require('./pages/index.vue').default,
    beforeEnter: mainPageGuard,
  },
  {
    path: '/index',
    component: require('./pages/index.vue').default,
    beforeEnter: mainPageGuard,
  },
  {
    path: '/machines',
    component: require('./pages/machines/index.vue').default,
    beforeEnter: permissionGuard('web_ta'),
  },
  {
    path: '/map',
    component: require('./pages/machines/map.vue').default,
    beforeEnter: permissionGuard('web_ta'),
  },
  {
    path: '/machines/:id',
    component: require('./pages/machines/_id.vue').default,
    props: true,
    children: [
      {
        path: 'matrixSendReceipts',
        component: require('./pages/machines/_id/matrixSendReceipts.vue').default,
        beforeEnter: permissionGuard('web_matrix_send_receipts'),
      },
      {
        path: '/',
        component: require('./pages/machines/_id/index.vue').default,
        beforeEnter: permissionGuard('web_ta_main'),
      },
      {
        path: 'money',
        component: require('./pages/machines/_id/money.vue').default,
        beforeEnter: permissionGuard('web_ta_main'),
      },
      {
        path: 'matrix',
        component: require('./pages/machines/_id/matrix.vue').default,
        beforeEnter: permissionGuard('web_ta_matrix'),
      },
      {
        path: 'modem',
        component: require('./pages/machines/_id/modem.vue').default,
        beforeEnter: permissionGuard('web_ta_modem'),
      },
      {
        path: 'schedule',
        component: require('./pages/machines/_id/schedule.vue').default,
        beforeEnter: permissionGuard('web_ta_schedule'),
      },
      {
        path: 'cards',
        component: require('./pages/machines/_id/cards.vue').default,
        beforeEnter: permissionGuard('web_ta_magnet'),
      },
      {
        path: 'eva',
        component: require('./pages/machines/_id/eva/index.vue').default,
        beforeEnter: permissionGuard('web_ta_eva'),
      },
      {
        path: 'eva/:eva_id',
        component: require('./pages/machines/_id/eva/_eva_id.vue').default,
        beforeEnter: permissionGuard('web_ta_eva'),
        props: true,
      },
    ],
  },
  {
    path: '/reports',
    redirect: '/reports/sales',
  },
  {
    path: '/reports/sales',
    component: require('./pages/reports/sales.vue').default,
    beforeEnter: permissionGuard('web_sales'),
  },
  {
    path: '/reports/expenditure',
    component: require('./pages/reports/expenditure.vue').default,
    beforeEnter: permissionGuard('web_rate'),
  },
  {
    path: '/reports/encashment',
    component: require('./pages/reports/encashment.vue').default,
    beforeEnter: permissionGuard('web_collect'),
  },
  {
    path: '/reports/events',
    component: require('./pages/reports/events/index.vue').default,
    beforeEnter: permissionGuard('web_events'),
  },
  {
    path: '/reports/events/:id',
    component: require('./pages/reports/events/_id.vue').default,
    beforeEnter: permissionGuard('web_events'),
    props: true,
  },
  {
    path: '/reports/downtime',
    component: require('./pages/reports/downtime.vue').default,
    beforeEnter: permissionGuard('web_downtime'),
  },
  {
    path: '/reports/notifications',
    component: require('./pages/reports/notifications.vue').default,
    beforeEnter: permissionGuard('web_alerts'),
  },
  {
    path: '/reports/receipts',
    component: require('./pages/reports/receipts.vue').default,
    beforeEnter: permissionGuard('web_bills'),
  },
  {
    path: '/reports/service',
    component: require('./pages/reports/service.vue').default,
    beforeEnter: permissionGuard('web_service'),
  },
  {
    path: '/reports/samples',
    component: require('./pages/reports/samples.vue').default,
  },
  {
    path: '/service',
    component: require('./pages/service.vue').default,
    beforeEnter: permissionGuard('web_service'),
  },
  {
    path: '/settings',
    redirect: '/settings/recipes/products',
  },
  {
    path: '/settings/recipes',
    redirect: '/settings/recipes/products',
  },
  {
    path: '/settings/recipes',
    component: require('./pages/settings/recipes.vue').default,
    beforeEnter: permissionGuard('web_matrix'),
    children: [
      {
        path: 'products',
        component: require('./pages/settings/recipes/products/index.vue').default,
      },
      {
        path: 'products/:id',
        component: require('./pages/settings/recipes/products/_id.vue').default,
      },
      {
        path: 'ingredients',
        component: require('./pages/settings/recipes/ingredients.vue').default,
      },
    ],
  },
  {
    path: '/settings/schedule',
    component: require('./pages/settings/schedule.vue').default,
    beforeEnter: permissionGuard('web_schedule'),
  },
  {
    path: '/settings/notifications',
    component: require('./pages/settings/notifications/index.vue').default,
    beforeEnter: permissionGuard('web_alert_settings'),
  },
  {
    path: '/settings/notifications/:id',
    props: true,
    component: require('./pages/settings/notifications/_id.vue').default,
    beforeEnter: permissionGuard('web_alert_settings'),
  },
  {
    path: '/settings/users',
    component: require('./pages/settings/users.vue').default,
    beforeEnter: permissionGuard('web_users'),
  },
  {
    path: '/settings/categories',
    component: require('./pages/settings/categories.vue').default,
    // beforeEnter: permissionGuard(''),
  },
  {
    path: '/admin',
    redirect: '/admin/limits',
  },
  {
    path: '/admin/ffd12',
    component: require('./pages/admin/ffd12-receipt-groups.vue').default,
    beforeEnter: permissionGuard('web_admin_ffd12'),
  },
  {
    path: '/admin/lists',
    component: require('./pages/admin/receipt-lists.vue').default,
    beforeEnter: permissionGuard('web_admin_ffd12'),
  },
  {
    path: '/admin/limits',
    component: require('./pages/admin/limits.vue').default,
    beforeEnter: permissionGuard('web_thresholds'),
  },
  {
    path: '/admin/documents',
    component: require('./pages/admin/documents.vue').default,
    beforeEnter: permissionGuard('web_checklist'),
    children: [
      {
        path: '/',
        component: require('./pages/admin/documents/index').default,
      },
      {
        path: 'checklists',
        component: require('./pages/admin/documents/checklists.vue').default,
      },
    ],
  },
  {
    path: '/help',
    component: require('./pages/help.vue').default,
  },
  {
    path: '/orders',
    component: require('./pages/orders.vue').default,
    beforeEnter: permissionGuard('web_requests'),
    children: [
      {
        path: '/',
        redirect: '/orders/equipment',
      },
      {
        path: 'equipment',
        component: require('./pages/orders/equipment/index.vue').default,
      },
      {
        path: 'ingredients',
        component: require('./pages/orders/ingredients/index.vue').default,
      },
      {
        path: 'ingredients/create',
        component: require('./pages/orders/ingredients/create.vue').default,
      },
      {
        path: 'equipment/create',
        component: require('./pages/orders/equipment/create.vue').default,
      },
      {
        path: 'equipment/:id',
        props: true,
        component: require('./pages/orders/equipment/_id.vue').default,
      },
      {
        path: 'ingredients/:id',
        props: true,
        component: require('./pages/orders/ingredients/_id.vue').default,
      },
    ],
  },
  {
    path: '/emulator',
    component: require('./pages/emulator.vue').default,
  },
  {
    path: '/modems',
    component: require('./pages/modems/index.vue').default,
    beforeEnter: permissionGuard('web_modems'),
    children: [
      {
        path: '/',
        component: require('./pages/modems/index/index.vue').default,
      },
      {
        path: 'deleted',
        component: require('./pages/modems/index/deleted.vue').default,
      },
      {
        path: 'broadcasts',
        component: require('./pages/modems/index/broadcasts/index.vue').default,
        beforeEnter: adminGuard,
      },
    ],
  },
  {
    path: '/modems/broadcasts/:id',
    props: true,
    component: require('./pages/modems/index/broadcasts/_id.vue').default,
    beforeEnter: adminGuard,
  },
  {
    path: '/modems/:uid',
    props: true,
    component: require('./pages/modems/_uid/index.vue').default,
    beforeEnter: permissionGuard('web_modems'),
  },
  {
    path: '/commands/:id',
    props: true,
    component: require('./pages/commands/_id.vue').default,
    beforeEnter: permissionGuard('web_modems'),
  },
  {
    path: '/receipts',
    component: require('./pages/receipts/index.vue').default,
    beforeEnter: permissionGuard('web_bills'),
  },
  {
    path: '/receipts/:id',
    props: true,
    component: require('./pages/receipts/_id.vue').default,
    beforeEnter: permissionGuard('web_bills'),
  },
  {
    path: '/queue',
    component: require('./pages/queue.vue').default,
  },
  ...(process.env.NODE_ENV === 'development' ? [
    {
      path: '/dev',
      component: require('./pages/dev.vue').default,
    },
  ] : []),
  {
    path: '*',
    component: require('./pages/not-found.vue').default,
  },
]



// WEBPACK FOOTER //
// ./resources/assets/js/routes.js